import {
  Capabilities,
  PaymentProfileCapability,
  stripePaymentProfileSchema,
} from '../../schemas/CapabilitiesSchema';
import { PaymentProfileOptionValue } from '../../types/Activity';

export const getPaymentProfile = (
  capabilities?: Capabilities
): PaymentProfileCapability | undefined => capabilities?.paymentProfile;

export const getBookingMethod = (capabilities?: Capabilities) =>
  capabilities?.bookingMethod;

export function getPaymentProfileOptionValue(
  paymentProfile: PaymentProfileCapability | undefined
): PaymentProfileOptionValue | undefined {
  if (!paymentProfile) return undefined;

  const parsedStripeConnect = stripePaymentProfileSchema.safeParse(
    paymentProfile
  );

  if (!parsedStripeConnect.success) return undefined;

  const {
    remittancePeriod,
    platformProcessingFee,
    remittanceSchedule,
    feeType,
  } = parsedStripeConnect.data;

  return {
    platformProcessingFee,
    remittanceSchedule,
    remittancePeriod,
    feeType,
  };
}

export function getPaymentProfileOptionLabel(
  paymentProfileOptionValue: PaymentProfileOptionValue
): string {
  const {
    remittancePeriod,
    platformProcessingFee,
    remittanceSchedule,
  } = paymentProfileOptionValue;

  if (remittanceSchedule === 'daysPrior' && remittancePeriod > 0) {
    return 'Delayed';
  } else if (remittanceSchedule === 'immediate' && platformProcessingFee > 0) {
    return 'Immediate';
  } else if (remittancePeriod === 0 && platformProcessingFee === 0) {
    return 'Legacy';
  } else {
    return 'Custom';
  }
}
